import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import * as moment from 'moment';
// import * as json2csv from 'json2csv';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { Global } from '../../../../app.global';
import { ReportsService } from '../../services/reports.service';

import { Constants } from '../../helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'team-reports',
  templateUrl: './team-reports.component.html',
  styleUrls: ['./team-reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeamReportsComponent implements OnInit {
  constants = Constants;
  selectedFilter = 'month';
  fromDate: Date = new Date();
  toDate: Date = new Date();
  currentDate = new Date();
  datePipeEn: DatePipe = new DatePipe('en-UK');
  loadingState = false;

  showCustomReportsDateRange = false;
  teamName = '';
  teamId = 0;
  teamReport = [];
  totalTeamReport = {};
  dateRangeText = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public global: Global,
    private reportsService: ReportsService
  ) {
    this.route.params.subscribe((params) => {
      if (params.teamId !== undefined) {
        this.teamId = params.teamId;
      }
    });
  }

  ngOnInit() {
    this.setTeamReports();
    this.setReportDateRange();
  }

  onChangeFilter(filterName) {
    if (this.selectedFilter === filterName) {
      return;
    }
    this.selectedFilter = filterName;
    if (filterName !== 'custom') {
      this.updateReports(filterName);
    }
  }

  updateReports(filterName) {
    this.showCustomReportsDateRange = filterName === 'custom';
    this.setTeamReports();
    this.setReportDateRange();
  }

  setTeamReports() {
    this.loadingState = true;
    this.reportsService
      .getTeamLeadPerformance(
        this.teamId,
        this.selectedFilter,
        this.fromDate,
        this.toDate
        // moment(this.fromDate).unix().toString(),
        // moment(this.toDate).unix().toString()
      )
      .subscribe(
        (result) => {
          this.teamName = result.teamLeaderName;
          this.teamReport = this.reportsService.getFormattedTeamsDepartmentReport(result.data);
          this.totalTeamReport = this.reportsService.getFormattedTotalTeamsDepartmentReport(
            result.total
          );
          this.loadingState = false;
        },
        (error) => {
          this.loadingState = false;
          console.log(error);
        }
      );
  }

  setReportDateRange() {
    this.dateRangeText = this.showCustomReportsDateRange
      ? `from ${this.datePipeEn.transform(this.fromDate, 'd MMMM y')}
        to ${this.datePipeEn.transform(this.toDate, 'd MMMM y')}`
      : `${this.selectedFilter} to ${this.datePipeEn.transform(this.currentDate, 'd MMMM y')}`;
  }

  downloadDocument(format) {
    if (format === 'excel') {
      const extraField = '';
      this.reportsService.exportExcelDocument(
        this.getTeamsReportExportJson(),
        this.getTeamsReportExportFields(),
        this.dateRangeText,
        extraField
      );
    } else {
      const reportsTable = document.getElementById('reports-table');
      const reportsTableClass = reportsTable.getAttribute('class');
      this.loadingState = true;
      reportsTable.classList.add('export-design');

      html2canvas(reportsTable, {
        scale: 3, // Increase the scale for better resolution
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jspdf('landscape', 'pt', 'a4');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'FAST'); // Set quality to 'FAST' for lower compression
        reportsTable.className = reportsTableClass;
        this.loadingState = false;
        pdf.save('reports.pdf');
      });
    }
  }

  getTeamsReportExportJson() {
    const dataList = [];

    this.teamReport.forEach((team) => {
      dataList.push(this.reportsService.exportDepartmentObject(team));
    });
    dataList.push(this.reportsService.exportDepartmentObject(this.totalTeamReport));

    return dataList;
  }

  getTeamsReportExportFields() {
    return [
      'team',
      'answered',
      'change',
      'of total',
      "canc'd",
      'bespoke',
      'override',
      'received',
      'quality change',
      'pp per day',
      'output rate change',
      'on letters',
    ];
  }
}
